import React, { Fragment, } from 'react';
import { Route, } from 'react-router';

import { Route as RouteType, } from 'routes';

type RoutesRenderType = {
    routes: RouteType[],
};

const RoutesRender: React.FC<RoutesRenderType> = ({ routes, }) => (
    <Fragment>
        {routes.map(({ routes, ...route }) => (
            <Fragment key={route.path}>
                <Route key={route.path}
                       exact={'exact' in route ? route.exact : true}
                       {...route}
                />
                {routes && <RoutesRender routes={routes} />}
            </Fragment>
        ))}
    </Fragment>
);

export default RoutesRender;
